import { render } from "./productive_hours_card.svg?vue&type=template&id=1852ca8c"
const script = {}
script.render = render

export default script